import { Component } from "react";
import { withRouter } from '../../common/with-router';
import { Card, Form, Button, Row, Col, Table, Dropdown } from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaTrash, FaEraser } from "react-icons/fa";
import api from "../../services/api";
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

class CentrosReferencia extends Component {
    constructor(props) {
        super(props);
        this.handleChangeBusca = this.handleChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaCentros = this.buscaCentros.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            page_numb: 1,
            loading: true,
            busca_nome: '',
        };
    }

    componentDidMount() {
        this.consultaRegistro(this.state.busca_nome, this.state.page_numb);
    }

    consultaRegistro(busca_nome = '', page_numb = 1) {
        let url = `/centros_referencia/?page=${page_numb}`;

        if (busca_nome) {
            url += `&nome=${busca_nome}`;
        }

        this.setState({ loading: true });

        api.get(url)
            .then(response => {
                this.setState({
                    loading: false,
                    error: "",
                    listRegistros: response.data,
                    busca_nome,
                    page_numb
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar os centros de referência, tente novamente.';

                if (error.response?.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response?.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg
                });
            });
    }

    renderRows = () => {
        if ('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0) {
            return this.state.listRegistros.results.map((item) =>
                <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nome}</td>
                    <td>{item.endereco ? `${item.endereco}, ${item.numero || 's/n'}` : '-'}</td>
                    <td>{item.cidade && item.uf ? `${item.cidade}/${item.uf}` : '-'}</td>
                    <td>{item.responsavel_recebimento || '-'}</td>
                    <td>{item.telefone || '-'}</td>
                    <td>
                        <Button variant="light" href={"/centros-referencia/edit/" + item.id} size="sm" className="me-1">
                            <FaRegEdit /> Editar
                        </Button>
                        <Button variant="danger" size="sm" onClick={() => this.confirmarExclusao(item.id)}>
                            <FaTrash /> Excluir
                        </Button>
                    </td>
                </tr>
            );
        }

        return (
            <tr>
                <td colSpan={7}>Nenhum centro de referência cadastrado</td>
            </tr>
        );
    };

    handleChangeBusca = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });

        this.consultaRegistro(this.state.busca_nome, num_page);
    }

    buscaCentros(e) {
        e.preventDefault();
        this.setState({ loading: true });
        this.consultaRegistro(this.state.busca_nome);
    }

    limpaFiltro = () => {
        this.setState({
            busca_nome: '',
            loading: true
        }, () => {
            this.consultaRegistro('', 1);
        });
    }

    confirmarExclusao = (id) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: 'Tem certeza?',
            text: "Esta ação não poderá ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.excluirCentro(id);
            }
        });
    }

    excluirCentro = (id) => {
        const MySwal = withReactContent(Swal);

        api.delete(`/centros_referencia/${id}/`)
            .then(() => {
                MySwal.fire(
                    'Excluído!',
                    'Centro de referência excluído com sucesso.',
                    'success'
                );
                this.consultaRegistro(this.state.busca_nome, this.state.page_numb);
            })
            .catch(error => {
                let erro_msg = 'Erro ao excluir o centro de referência.';
                if (error.response?.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                }
                MySwal.fire('Erro!', erro_msg, 'error');
            });
    }

    render() {
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Centros de Referência</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/centros-referencia/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Centro
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaCentros}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="busca_nome"
                                                                value={this.state.busca_nome}
                                                                onChange={this.handleChangeBusca}
                                                                placeholder="Nome do centro"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>
                                                <Button type="button" variant="light" size="sm" onClick={this.limpaFiltro}>
                                                    <FaEraser /> Limpar Filtro
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Endereço</th>
                                    <th>Cidade/UF</th>
                                    <th>Responsável</th>
                                    <th>Telefone</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                    <tr>
                                        <td colSpan={7}>Carregando...</td>
                                    </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={7}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>
                        {
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 &&
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default withRouter(CentrosReferencia);
